'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  authToken: (0, _immutable.Map)({
    token: null,
    expiresAtMs: null
  }),
  channels: null,
  timeToken: null,
  publishKey: null,
  subscribeKey: null,
  agentReady: null
}, 'ChatConfig');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/ChatConfig.js
// module id = 528
// module chunks = 0